// extracted by mini-css-extract-plugin
module.exports = {"link":"BigLink-module--link--2CGrG","stroke":"BigLink-module--stroke--wTqC5"};